export default "__VITE_ASSET__BJS_tamU__"